<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-menu-button></ion-menu-button>
        </ion-buttons>
        <ion-title>
            Instellingen
        </ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-item>
        <ion-label>Hide Scan button</ion-label>
        <ion-toggle [(ngModel)]="global.optHideScanBtn" (ngModelChange)="chHideScanBtn()"></ion-toggle>
    </ion-item>
    <ion-item>
        <ion-label>Start op pagina</ion-label>
        <mat-form-field appearance="fill">
            <mat-select (selectionChange)='chPage()' [(ngModel)]="global.startPage">
                <mat-option *ngFor="let pg of visiblePages(app.appPages)" [value]="pg.url">
                    {{ pg.title }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </ion-item>
    <ion-item>
        <ion-label>Prijzen incl. BTW</ion-label>
        <ion-toggle [(ngModel)]="global.optInclBtw" (ngModelChange)="chBTW()"></ion-toggle>
    </ion-item>
    <ion-button size="large" expand="block" [routerLink]="global.startPage">OK</ion-button>
</ion-content>
